import React from 'react';

/**
 * Switch — on/off toggle. Green when on. Optional label.
 */
export function Switch({ checked, defaultChecked = false, onChange, label, disabled = false, style = {}, ...rest }) {
  const [internal, setInternal] = React.useState(defaultChecked);
  const on = checked ?? internal;
  const toggle = () => {
    if (disabled) return;
    const next = !on;
    if (checked === undefined) setInternal(next);
    onChange && onChange(next);
  };
  const track = (
    <span
      role="switch"
      aria-checked={on}
      onClick={toggle}
      style={{
        width: 44, height: 26, borderRadius: 999, flexShrink: 0,
        background: on ? 'var(--brand-green)' : 'var(--surface-2)',
        border: `1px solid ${on ? 'var(--brand-green)' : 'var(--border-strong)'}`,
        position: 'relative', cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background .18s ease', opacity: disabled ? 0.5 : 1,
      }}
    >
      <span style={{
        position: 'absolute', top: 2, left: on ? 20 : 2, width: 20, height: 20, borderRadius: 999,
        background: '#fff', transition: 'left .18s cubic-bezier(.22,1,.36,1)',
        boxShadow: '0 1px 3px rgba(0,0,0,.35)',
      }} />
    </span>
  );
  if (!label) return <span style={style} {...rest}>{track}</span>;
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 12, cursor: disabled ? 'not-allowed' : 'pointer', fontFamily: 'var(--font-sans)', ...style }} {...rest}>
      {track}
      <span style={{ fontSize: 'var(--fs-body)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-body)' }}>{label}</span>
    </label>
  );
}
